import styled from '@emotion/styled';

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
`;
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
`;
export const Title = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	padding-bottom: 1.6rem;
	border-bottom: 1px solid #adb5bd;
`;
export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;
export const SelectBox = styled.div`
	height: 4.4rem;
`;
export const FieldCheckBox = styled.label`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	justify-content: flex-end;
`;
export const GuideBox = styled.div`
	display: flex;
	flex-direction: column;
`;
export const GuideTextStrong = styled.p`
	color: ${(props) => props.theme.colors.red600};
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;
export const GuideText = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;
export const NextButton = styled.button`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;
export const AddButton = styled(NextButton)`
	border: 1px solid #212529;
	background-color: #fff;
	color: #212529;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.2rem;
`;
export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 0.4rem;
	width: 100%;
`;
export const Input = styled.input``;
export const GenderBox = styled.div`
	display: flex;
	gap: 4rem;
`;
export const GenderRadio = styled.div`
	display: flex;
	gap: 0.4rem;
`;
export const AddressInput = styled.input`
	width: 100%;
	&:read-only {
		background-color: #e9ecef;
		border: 1px solid #adb5bd;
	}
`;
export const FindButton = styled.button`
	background-color: #212529;
	color: #fff;
	padding: 0 1.2rem;
	white-space: nowrap;
	min-width: 8rem;
	border: none;
	height: 100%;
	flex-shrink: 0; /* 버튼이 줄어들지 않도록 설정 */
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
`;
export const AddressBox = styled.div`
	display: flex;
	gap: 0.4rem;
	height: 4.4rem;
`;
export const AddressContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
`;
export const TabBox = styled.div`
	display: flex;
	width: 100%;
	height: 4.4rem;
	background-color: #fff;
	color: #868e96;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	.tab {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		height: 100%;
		border: 1.4px solid #adb5bd;
		&.active {
			border: 1px solid ${(props) => props.theme.colors.primary400};
			color: ${(props) => props.theme.colors.primary400};
		}
	}
`;
export const Danger = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: ${(props) => props.theme.colors.red600};
`;
